import React, { useState } from 'react';
import { getSession } from '../services/storage-service';
import { getLoginBusinessId } from '../services/auth-details-service';

export default function useUserInfo() {
  /* The code `const userData = useSelector((state) => state?.auth?.loginUserData);` is using the
 `useSelector` hook from the `react-redux` library to select the `loginUserData` property from the
 `auth` slice of the Redux store. It assigns the selected value to the `userData` variable. */
  const businessId = getLoginBusinessId();
  const [userAccountObj, setUserAccountObj] = useState(null);

  /**
   * The function `userSvcTypeData` returns the value of `svcType` from the `objPermissions` property
   * of `userAccountObj` if it exists.
   * @param svcType - The `svcType` parameter is a string that represents the service type.
   * @returns the value of `userAccountObj?.objPermissions?.[svcType]` if `svcType` is truthy.
   */
  const userSvcTypeData = (svcType) => {
    const userAccountObjStorage = getSession(`${businessId}_biz_Accocunt_user_obj`, true);
    if (svcType) {
      return userAccountObjStorage?.objPermissions?.[svcType];
    }
  };

  /* The `React.useEffect` hook is used to perform side effects in a functional component. In this
  case, it is used to retrieve the `userAccountObj` from the local storage and update the state
  variable `userAccountObj` when the `userData` dependency changes. */
  React.useEffect(() => {
    const userAccountObjStorage = getSession(`${businessId}_biz_Accocunt_user_obj`, true);
    if (userAccountObjStorage) setUserAccountObj(userAccountObjStorage);
  }, [businessId]);

  return { userAccountObj, userSvcTypeData };
}
